import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faPen, faFolderOpen, faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import ModalRequestAndAddProject from "Components/ModalRequestAndAddProject/ModalRequestAndAddProject";
import { toast } from "react-toastify";
import { collection, doc, getDocs, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase"; // Adjust import path if necessary
import HeaderPages from "Components/HeaderPages/HeaderPages";
import "../MyProjects/Projects.css";

const Testimonials = () => {
  const { t } = useTranslation(); // Initialize the useTranslation hook
  const [cards, setCards] = useState([]);
  const [showModal, setShowModalSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useNavigate();

  // Fetch cards from Firestore
  const fetchCards = async () => {
    setLoading(true);
    try {
      const collectionRef = collection(db, "testimonials", "testimonials", "Cards");
      const snapshot = await getDocs(collectionRef);
      const cardsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCards(cardsData);
    } catch (error) {
      console.error("Error fetching cards:", error);
      toast.error(t("Failed to load testimonials") || "Failed to load testimonials");
    } finally {
      setLoading(false);
    }
  };

  // Handle card deletion
  const handleDeleteCard = async (cardId) => {
    try {
      const docRef = doc(db, "testimonials", "testimonials", "Cards", cardId);
      await deleteDoc(docRef);
      // Remove the deleted card from state
      setCards(cards.filter((card) => card.id !== cardId));
      toast.success(t("CardDeletedSuccessfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deleting card:", error);
      toast.error(t("CardDeletionFailed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  // Fetch cards on component mount
  useEffect(() => {
    fetchCards();
  }, []);

  // Handle modal actions
  const handleCloseModal = () => {
    setShowModalSuccess(false);
    router("/home");
  };

  const handleOpenModalSuccess = () => {
    setShowModalSuccess(true);
  };

  return (
    <>
      <HelmetInfo titlePage={t("Testimonials")} />
      <ModalRequestAndAddProject
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />
      <div className="project-management-request all-main my-projects-container">
        {/* Render Breadcrumb */}
        <HeaderPages titlePage={t("Testimonials")} />

        {/* Enhanced Page Header */}
        <div className="my-projects-header">
          <div className="header-info">
            <h1>{t("Testimonials")}</h1>
            <p>{t("View and manage patient stories and feedback displayed on the landing page")}</p>
          </div>
          <Link
            className="btn-add-service"
            to={"/AddNewTestimonials"}
          >
            <FontAwesomeIcon icon={faPlus} />
            {t("add New testimonials")}
          </Link>
        </div>

        <div className="form-project-management">
          <div className="row Servcis-Cards g-4">
            {loading ? (
              // Skeleton Loader Grid
              Array.from({ length: 4 }).map((_, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6" key={`skeleton-${index}`}>
                  <div className="skeleton-card">
                    <div className="skeleton-icon" style={{ borderRadius: "50%" }}></div>
                    <div className="skeleton-title" style={{ width: "50%" }}></div>
                    <div className="skeleton-text"></div>
                    <div className="skeleton-text"></div>
                    <div className="skeleton-text short"></div>
                    <div className="skeleton-actions">
                      <div className="skeleton-btn-edit"></div>
                      <div className="skeleton-btn-delete"></div>
                    </div>
                  </div>
                </div>
              ))
            ) : cards.length === 0 ? (
              // Empty State UI
              <div className="col-12 text-center">
                <div className="my-projects-empty-state">
                  <div className="empty-state-icon-container">
                    <FontAwesomeIcon icon={faFolderOpen} />
                  </div>
                  <h3>{t("No Testimonials Found") || "No Testimonials Found"}</h3>
                  <p>
                    {t("There are no testimonials added yet. Click below to add patient reviews to showcase on the front page.")}
                  </p>
                  <Link
                    className="btn-add-service"
                    to={"/AddNewTestimonials"}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    {t("Add Testimonial")}
                  </Link>
                </div>
              </div>
            ) : (
              // Cards grid list
              cards.map((card) => (
                <div className="col-lg-3 col-md-4 col-sm-6" key={card.id}>
                  <div className="service-card testimonial-card">
                    <FontAwesomeIcon icon={faQuoteLeft} style={{ fontSize: "24px", color: "rgba(0, 44, 99, 0.08)", marginBottom: "12px" }} />
                    <h5>{card.Name}</h5>
                    <p>{card.Text}</p>
                    <div className="card-actions">
                      <Link
                        className="btn-card-action-edit"
                        to={`/AddNewTestimonials?edit=${card.id}`}
                      >
                        <FontAwesomeIcon icon={faPen} />
                        <span>{t("Edit")}</span>
                      </Link>
                      <button
                        className="btn-card-action-delete"
                        onClick={() => handleDeleteCard(card.id)}
                        title={t("Delete")}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
